import axios from "axios";
import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { baseUrl } from "./Univ";

function AddPartyVote() {
  const [rows, setRows] = useState([]);
  const [results, setResults] = useState([]);
  const [parties, setParties] = useState([]);

  const [form, setForm] = useState({
    result: "",
    party: "",
    votes: ""
  });

  // ---------------- FETCH ----------------
  const fetchData = () => {
    axios.get(baseUrl + "party-votes/").then(r => setRows(r.data));
  };

  useEffect(() => {
    fetchData();
    axios.get(baseUrl + "results/").then(r => setResults(r.data));
    axios.get(baseUrl + "parties/").then(r => setParties(r.data));
  }, []);

  // ---------------- SUBMIT ----------------
  const submit = () => {

    if (!form.result || !form.party) {
      Swal.fire("Error", "Select Result & Party", "error");
      return;
    }

    const payload = {
      result: form.result,
      party: form.party,
      votes: form.votes === "" ? null : parseInt(form.votes)
    };

    axios.post(baseUrl + "party-votes/", payload)
      .then(() => {
        Swal.fire("Saved", "Vote added", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch(err => {
        console.log(err.response?.data);
        Swal.fire("Error", "Failed to save", "error");
      });
  };

  // ---------------- DELETE ----------------
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This vote will be deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Delete"
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "delete-party-votes/" + id + "/")
          .then(() => {
            Swal.fire("Deleted!", "", "success");
            fetchData();
          });
      }
    });
  };

  // ---------------- DATAGRID ----------------
  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    {
      field: "result",
      headerName: "Constituency",
      width: 200,
      renderCell: (params) => {
        const r = params.value;
        return `${r?.constituency?.name || ""} (${r?.election?.name || ""})`;
      }
    },

    {
      field: "party",
      headerName: "Party",
      width: 150,
      renderCell: (params) => params.value?.name || "-"
    },

    { field: "votes", headerName: "Votes", width: 120 },

    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <button
          className="btn btn-sm btn-danger"
          onClick={() => handleDelete(params.row.id)}
        >
          Delete
        </button>
      ),
    }
  ];

  // ---------------- UI ----------------
  return (
    <section className="container mt-4">

      {/* ===== FORM ===== */}
      <div className="card">
        <h4 className="card-header">Add Party Vote</h4>

        <div className="card-body">

          {/* RESULT DROPDOWN */}
          <select
            className="form-control mb-3"
            value={form.result}
            onChange={e => setForm({ ...form, result: e.target.value })}
          >
            <option value="">-- Select Constituency Result --</option>
            {results.map(r => (
              <option key={r.id} value={r.id}>
                {r.constituency?.name} ({r.election?.name})
              </option>
            ))}
          </select>

          {/* PARTY DROPDOWN */}
          <select
            className="form-control mb-3"
            value={form.party}
            onChange={e => setForm({ ...form, party: e.target.value })}
          >
            <option value="">-- Select Party --</option>
            {parties.map(p => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>

          {/* VOTES */}
          <input
            type="number"
            className="form-control mb-3"
            placeholder="Votes"
            value={form.votes}
            onChange={e => setForm({ ...form, votes: e.target.value })}
          />

          <button className="btn btn-primary" onClick={submit}>
            Save Vote
          </button>

        </div>
      </div>

      {/* ===== DATAGRID ===== */}
      <div style={{ width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          pageSize={25}
          rowsPerPageOptions={[25, 50, 100]}
          components={{ Toolbar: GridToolbar }}
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
          }}
        />
      </div>

    </section>
  );
}

export default AddPartyVote;